// extracted by extract-css-chunks-webpack-plugin
module.exports = {"TabNav":"TabNav_2fcwM_v16-5-1","TabNav_Items":"TabNav_Items_1fV0a_v16-5-1","TabNav_Aux":"TabNav_Aux_1Bccp_v16-5-1"};